import React from "react";
import { useSelector, useDispatch } from "react-redux";

import Button from "../../../UI/Button/CustomButtonLeftPanelBlue";
import { Container, ButtonContainer } from "./ButtonsStyles";
import { clearSelectedPatterns } from "../../../../redux/slices/selectedPatterns";
import {
  setGridDisplay,
  setHomeDisplay,
} from "../../../../redux/slices/display";
import { selectTotalSPatterns } from "../../../../redux/slices/selectedPatterns";
import getPatternBars from "./utils/getPatternBars";
import createNodalRepresentation from "./utils/createNodalRepresentation";
import coldStartDrawNodalRepresentation from "./utils/coldStartDrawNodalRepresentation";
import { saveCurrentShape } from "../../../../redux/slices/coldStart";
import { coldTrainModel } from "../../../../redux/slices/models";
import { detectPatternsForUnsavedModel } from "../../../../redux/slices/detectedPatterns";
import { setTrained } from "../../../../redux/slices/toolbar";

export default function Buttons({ drawModel, setLoading }) {
  const dispatch = useDispatch();

  // Select from redux store
  const mode = useSelector(({ display }) => display.mode);
  const detectingPatterns = useSelector(
    ({ detectedPatterns }) => detectedPatterns.fetching
  );
  const selectedPatternsNumber = useSelector(selectTotalSPatterns);

  // Handler functions
  const trainModel = async () => {
    setLoading(true);
    for (let i = 0; i < selectedPatternsNumber; i++) {
      const bars = getPatternBars(i);
      const nodalRepresentation = await createNodalRepresentation(bars, 12);
      coldStartDrawNodalRepresentation(nodalRepresentation, dispatch);
      dispatch(saveCurrentShape());
    }

    await dispatch(coldTrainModel(selectedPatternsNumber));

    dispatch(setGridDisplay());
    await dispatch(detectPatternsForUnsavedModel());
    dispatch(setTrained(true));
  };

  return (
    <Container>
      {mode === "selectPatternsForTraining" && (
        <Button onClick={() => dispatch(clearSelectedPatterns())}>
          Remove all selected rectangles
        </Button>
      )}

      <ButtonContainer>
        {drawModel ? (
          <Button onClick={trainModel} disabled={selectedPatternsNumber < 1}>
            Train Model
          </Button>
        ) : (
          <Button
            onClick={() => {
              dispatch(setGridDisplay());
            }}
          >
            View all detected patterns
          </Button>
        )}
      </ButtonContainer>

      <ButtonContainer>
        <Button
          onClick={() => dispatch(setHomeDisplay())}
          disabled={detectingPatterns}
        >
          Start again
        </Button>
      </ButtonContainer>
    </Container>
  );
}
